import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

import { LayerQcService } from './../../../services/layer-qc.service';
import { SocketService, SocketLog } from './../../../services/socket.service';

@Component({
	selector: 'app-jobs-qc-logs',
	templateUrl: './jobs-qc-logs.component.html',
	styleUrls: ['./jobs-qc-logs.component.css']
})
export class JobsQcLogsComponent implements OnInit, OnDestroy {

	public currentLog: SocketLog;
	private qcLogsSub: Subscription;
	//
	private routeParamsSub: Subscription;
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private qcService: LayerQcService,
		private socketService: SocketService
		// private stateService: StateService
	) { }

	viewData() {
		// this.stateService.go('jobsqc');
		this.router.navigate(['azgiv/review/qc-view']);
	}
	ngOnInit() {
		// Get processId
		let processId;
		this.routeParamsSub = this.route.paramMap.subscribe((params) => {
			processId = params.get('processId');
		});
		this.qcLogsSub = this.qcService.qcLogs.subscribe((data) => {
			// const processId = this.stateService.params.processId;
			this.currentLog = this.socketService.getCurrentSocketLog(processId, data);
		});
	}
	ngOnDestroy() {
		this.qcLogsSub.unsubscribe();
		this.routeParamsSub.unsubscribe();
	}

}
